import { Component, OnInit, Optional, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { BreakpointObserver, BreakpointState } from '@angular/cdk/layout';

@Component({
  selector: 'bil-bil-delete-itr',
  templateUrl: './bil-delete-itr.component.html',
  styleUrls: ['./bil-delete-itr.component.sass']
})
export class BilDeleteItrComponent implements OnInit {

  public isMobile: boolean;
  constructor(
    private dialogRef: MatDialogRef<BilDeleteItrComponent>,
    private breakpointObserver: BreakpointObserver,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    breakpointObserver
      .observe(['(min-width: 600px)'])
      .subscribe((state: BreakpointState) => {
        if (state.matches) {
          this.isMobile = false;
        } else {
          this.isMobile = true;
        }
      });
  }

  ngOnInit() {
  }

  close() {
    this.dialogRef.close();
  }

}
